import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import axios from "axios";
import * as auth from "./auth";
import { EventBus } from "@/js/events/bus.js";
var mutex = false;
export function sleep(_x) {
  return _sleep.apply(this, arguments);
}
function _sleep() {
  _sleep = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(msec) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve) {
            return setTimeout(resolve, msec);
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _sleep.apply(this, arguments);
}
var attempts = 0;
var maxAttempts = 5;
export function refreshToken() {
  try {
    var refreshDatas = {
      refresh_token: auth.getRefreshToken(),
      client_id: window.whitelabel.clientId,
      client_secret: window.whitelabel.clientSecret,
      id_user: auth.getIdUserFromToken(),
      grant_type: "token"
    };
    return axios({
      method: "put",
      url: process.env.VUE_APP_CAP_URL + "/v1/gate/token",
      headers: null,
      data: refreshDatas
    }).then(function (response) {
      attempts = 0;
      auth.setRefreshToken(response.data.refresh_token);
      auth.setAccessToken(response.data.access_token);
    }).catch(function (error) {
      var _error$response;
      //Invalid Token
      //This condition prevent SPAM in devMode causing sqlBan
      attempts++;
      if ((error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401 || process.env.NODE_ENV === "production") {
        if (attempts >= maxAttempts) {
          try {
            auth.disconnect();
            attempts = 0;
          } catch (e) {
            throw e;
          }
        }
      }
    });
  } catch (_unused) {
    attempts = 0;
    auth.clearStorage();
    window.location.pathname = "login";
  }
}
export function request(_x2, _x3, _x4, _x5, _x6, _x7, _x8) {
  return _request.apply(this, arguments);
}
function _request() {
  _request = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(uri, verb, data, authorizedResource, target, responseType, cancelTokenSource) {
    var headers, url, respType;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(auth.isAccessTokenExpired() && !!authorizedResource)) {
            _context2.next = 9;
            break;
          }
          if (mutex) {
            _context2.next = 6;
            break;
          }
          mutex = true;
          _context2.next = 5;
          return refreshToken();
        case 5:
          mutex = false;
        case 6:
          _context2.next = 8;
          return sleep(500);
        case 8:
          return _context2.abrupt("return", request(uri, verb, data, authorizedResource, target, responseType, cancelTokenSource));
        case 9:
          headers = {};
          if (authorizedResource) {
            headers = {
              Authorization: auth.getAuthHeaderFromToken(auth.getAccessToken())
            };
          }
          document.body.style.cursor = "wait";
          url = "";
          respType = "json";
          if (responseType != "" && responseType != null) {
            respType = responseType;
          }
          if (target === "cap") {
            url = process.env.VUE_APP_CAP_URL;
          } else if (target === "api") {
            url = process.env.VUE_APP_API_URL;
          }
          url = url + uri;
          return _context2.abrupt("return", axios({
            method: verb,
            url: url,
            headers: headers,
            data: data,
            responseType: respType,
            cancelToken: cancelTokenSource === null || cancelTokenSource === void 0 ? void 0 : cancelTokenSource.token
          }).then(function (response) {
            document.body.style.cursor = "default";
            return response;
          }).catch(function (e) {
            document.body.style.cursor = "default";
            // we add this event, to stop the loader every time there is an error in a http request, so we do not have to do this in every component calling this method
            EventBus.$emit("loading", false);
            throw e;
          }));
        case 18:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _request.apply(this, arguments);
}